import React from 'react';
import { RocketIcon } from 'lucide-react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
  external?: boolean;
  className?: string;
}
export function CtaButton({
  href,
  children,
  size = 'md',
  external = false,
  className = ''
}: CtaButtonProps) {
  const sizes: Record<string, string> = {
    md: 'px-4 py-3 text-sm sm:text-base',
    lg: 'px-4 py-4 text-base sm:text-lg'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : undefined} className={`group inline-flex w-full items-center justify-center gap-2 rounded-lg border-b-4 border-alert-dark bg-alert text-center font-sans font-extrabold uppercase leading-tight tracking-tight text-white shadow-lg shadow-alert/25 transition-[background-color,transform] duration-150 ease-soft hover:bg-alert-dark active:translate-y-0.5 ${sizes[size]} ${className}`} data-id="element-199" data-mp="1m438fkhff2u0">
      <RocketIcon size={size === 'lg' ? 20 : 17} className="flex-shrink-0" aria-hidden="true" data-id="element-200" data-mp="187pqybcw71fj" />
      <span data-id="element-201" data-mp="2chqd2t9xysxb">{children}</span>
    </a>;
}